import React from "react";
import { useAtom } from "jotai";
import { highContrastAtom } from "../jotai/atoms";
import { WHITELABEL_KEY } from "../globals";
import { twMerge } from "tailwind-merge";

// Simple wrapper component to pull in high contrast mode from Jotai state
// and apply it to the root element of the app.
export default function HighContrastWrapper({ children }: { children: React.ReactNode }) {
  const [highContrast] = useAtom(highContrastAtom);

  return (
    <div
      {...(highContrast && WHITELABEL_KEY !== "nj" ? { "data-theme": "highcontrast" } : {})}
      className="h-full max-md:bg-secondary md:bg-linear-to-b from-neutral to-secondary max-md:has-[.override-bg-to-neutral]:bg-neutral has-[.override-bg-use-gradient]:bg-linear-to-b pt-[env(safe-area-inset-top)]"
    >
      {children}
    </div>
  );
}
